module.exports = __webpack_public_path__ + "img/client.24481c77.svg";